import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'cep');

const cepActions = {
  obter: { method: 'GET', url: `${basePath}/{cep}` },
};

export default resource => resource(`${basePath}`, {}, cepActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/cep.js